import {NgModule} from '@angular/core';
import {AbstractToolWrapper} from 'app/tool-layer/class/tool-wrapper';
import {DigitalClockComponent} from 'app/tool-layer/tools/digital-clock/digital-clock.component';
import {ComponentModule} from 'app/component/component.module';
import {CommonModule} from '@angular/common';

@NgModule({
    imports: [ComponentModule, CommonModule],
    declarations: [DigitalClockComponent],
    providers: [
        {
            provide: AbstractToolWrapper,
            useValue: AbstractToolWrapper.create(DigitalClockComponent),
            multi: true,
        },
    ],
})
export class DigitalClockModule {}
